// ui/presenters/authorizationFundingSources.js
import { selectableFundingSources } from './selectableFundingSources';

/**
 * Which funding sources the authorization editor offers: only payers the client has coverage with.
 *
 * A letter only clears items billed to the payer that wrote it, so one recorded against a payer the
 * client has no coverage with clears nothing, while the Authorizations tab shows it as valid.
 *
 * ENDED AND SECONDARY COVERAGES COUNT. A letter from a previous payer still has to clear the sessions
 * that payer covered. Only a deleted coverage drops out.
 *
 * `keepId` stays on offer even outside the client's coverages, so an authorization recorded against
 * the wrong payer still opens showing it and can be corrected.
 *
 * @param {import('../../domain/model/FundingSource.types').FundingSource[]} fundingSources
 * @param {import('../../domain/model/Coverage.types').Coverage[]} coverages - including tombstones
 * @param {string|null} [keepId] - the payer the authorization being edited already names
 * @returns {import('../../domain/model/FundingSource.types').FundingSource[]}
 */
// eslint-disable-next-line import/prefer-default-export
export function authorizationFundingSources(fundingSources, coverages, keepId = null) {
  const covered = new Set((coverages ?? [])
    .filter((coverage) => coverage.isDeleted !== true)
    .map((coverage) => coverage.fundingSourceId));

  return selectableFundingSources(fundingSources, keepId)
    .filter((fundingSource) => covered.has(fundingSource.fundingSourceId) || fundingSource.fundingSourceId === keepId);
} // authorizationFundingSources()
